/**
 * 💡 Utility function to format time difference (similar to moment.js/timeago)
 * @param {string} dateString - The ISO 8601 string of the last update time.
 * @returns {string} - Formatted duration (e.g., '1d ago', '3h ago', '23m ago').
 */
export const formatTimeAgo = (dateString) => { // <-- ADD 'export' HERE
 if (!dateString) return null;
 
 // Calculate difference in milliseconds
 const now = Date.now();
 const past = new Date(dateString).getTime();
 const diffMs = now - past;
 
 // Convert milliseconds to units
 const minutes = Math.floor(diffMs / (1000 * 60));
 const hours = Math.floor(minutes / 60);
 const days = Math.floor(hours / 24);

 if (days > 0) {
  return `${days}d ago`;
 }
 if (hours > 0) {
  return `${hours}h ago`;
 }
 if (minutes > 0) {
  return `${minutes}m ago`;
 }
 // Less than a minute ago
 return 'just now';
};